module.exports = __webpack_public_path__ + "static/img/preview-01.973018d7.webp";